import React from "react";

const clean = (p) => {
  let d = String(p || "").replace(/[\s\-().]/g, "");
  if (d.startsWith("+")) d = d.slice(1);
  if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  else if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return d;
};
export const isValidInMobile = (p) => /^[6-9]\d{9}$/.test(clean(p));

export const CONSENT_OPTS = [{ value: "no", label: "No consent recorded" }, { value: "yes", label: "Yes — consent given" }];
export const CONSENT_METHODS = [
  { value: "paper", label: "Signed paper form" }, { value: "verbal", label: "Verbal (in meeting)" },
  { value: "sms", label: "SMS reply" }, { value: "other", label: "Other" },
];

export const validateConsent = (v) => {
  if (v.whatsapp_consent !== "yes") return {};
  const e = {};
  if (!v.phone) e.phone = "A mobile number is needed for WhatsApp consent";
  if (!v.consent_date) e.consent_date = "Enter the date consent was given";
  else if (v.consent_date > new Date().toISOString().slice(0, 10)) e.consent_date = "Cannot be in the future";
  if (!v.consent_method) e.consent_method = "Choose how consent was recorded";
  return e;
};

export const whatsappEligibility = (r) => {
  if (!r.phone) return { ok: false, label: "No number" };
  if (!isValidInMobile(r.phone)) return { ok: false, label: "Invalid number" };
  if (r.whatsapp_consent !== "yes") return { ok: false, label: "No consent" };
  return { ok: true, label: "Consent ✓" };
};

export const WhatsAppBadge = ({ row }) => {
  const e = whatsappEligibility(row);
  return (
    <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold ${e.ok ? "border-emerald-300 bg-emerald-100 text-emerald-800" : "border-slate-300 bg-slate-100 text-slate-600"}`}>
      {e.label}
    </span>
  );
};
